const state = {
    documentsToUpload: {},
    documentsToSend: {},
    documentsList: {},
    applicants: [],
    dataValidation: [],
    totalIncomeServicing: '',
    totalWeeklyIncome: '',
    totalMontlyIncome: '',
    totalWeeklyExpense: '',
    totalMonthlyExpense: '',
    totalMonthlyDebt: '',
    availableMonthlySurplus: '',
    netPosition: '',
    investmentPropertyIncomes: [],
    emailRecipients: [],
    sendReviewRequest: '',
    noReviewRequestReason: '',
    reviewRequestBy: '',
    relatedLoanTiers: [],
    selectedTier: null
}

const getters = {
    documentsToUpload: (state) => state.documentsToUpload,
    documentsToSend: (state) => state.documentsToSend,
    documentsList: (state) => state.documentsList,
    applicants: (state) => state.applicants,
    dataValidation: (state) => state.dataValidation,
    totalIncomeServicing: (state) => state.totalIncomeServicing,
    totalWeeklyIncome: (state) => state.totalWeeklyIncome,
    totalMonthlyIncome: (state) => state.totalMonthlyIncome,
    totalWeeklyExpense: (state) => state.totalWeeklyExpense,
    totalMonthlyExpense: (state) => state.totalMonthlyExpense,
    totalMonthlyDebt: (state) => state.totalMonthlyDebt,
    availableMonthlySurplus: (state) => state.availableMonthlySurplus,
    netPosition: (state) => state.netPosition,
    investmentPropertyIncomes: (state) => state.investmentPropertyIncomes,
    emailRecipients: (state) => state.emailRecipients,
    getSendReviewRequest: (state) => state.sendReviewRequest,
    getNoReviewRequestReason: (state) => state.noReviewRequestReason,
    getReviewRequestBy: (state) => state.reviewRequestBy,
    getRelatedLoanTiers: (state) => state.relatedLoanTiers,
    getSelectedTier: (state) => state.selectedTier,
}

const mutations = {
    saveDocumentsToUpload(state, documents) {
        state.documentsToUpload = documents
    },
    setInvestmentPropertyIncomes(state, investmentPropertyIncomes) {
        state.investmentPropertyIncomes = investmentPropertyIncomes
    },
    saveDocumentsToSend(state, documents) {
        state.documentsToSend = documents
    },
    saveApplicants(state, applicants) {
        state.applicants = applicants
    },
    saveDataValidation(state, dataValidation) {
        state.dataValidation = dataValidation
    },
    setDocumentsList(state, documentsList) {
        state.documentsList = documentsList
    },
    setEmailRecipients(state, emailRecipients) {
        state.emailRecipients = emailRecipients
    },
    setSendReviewRequest(state, request) {
        state.sendReviewRequest = request
    },
    setNoReviewRequestReason(state, reason) {
        state.noReviewRequestReason = reason
    },
    setReviewRequestBy(state, id) {
        state.reviewRequestBy = id
    },
    setRelatedLoanTiers(state, relatedTiers) {
        state.relatedLoanTiers = relatedTiers
    },
    setSelectedTier(state, selectedTier) {
        state.selectedTier = selectedTier
    },
}

const actions = {
    setInvestmentPropertyIncomes(context, investmentPropertyIncomes) {
        context.commit('setInvestmentPropertyIncomes', investmentPropertyIncomes)
    },
    saveDocumentsToReturn(context, documents) {
        context.commit('saveDocumentsToUpload', documents)
    },
    saveDocumentsToSend(context, documents) {
        context.commit('saveDocumentsToSend', documents)
    },
    saveApplicants(context, applicants) {
        context.commit('saveApplicants', applicants)
    },
    saveDataValidation(context, dataValidation) {
        context.commit('saveDataValidation', dataValidation)
    },
    setDocumentsList(context, documentsList) {
        context.commit('setDocumentsList', documentsList)
    },
    fetchEmailRecipients(context, data) {
        axios
            .get("/api/recipients/" + $store.getters.appId)
            .then((res) => {
                context.commit('setEmailRecipients', res.data)
            })
    },
    async matchesLoanContract({ commit }, payload) {
        const { token, appId } = payload
        // const headers = { Authorization: "Bearer " + token }
        const headers = { Authorization: "Bearer " + token }
        const response = await axios({
            method: 'get', headers, url: `/api/v3/application/${appId}/confirm-fls`
        })
        return response.data
        // return axios.get(`/api/v3/application/${appId}/confirm-fls`, headers).then(async ({ data }) => {
        //
        // })
        // return new Promise((resolve, reject) => {})
    },
    setSendReviewRequest(context, request) {
        context.commit('setSendReviewRequest', request)
    },
    setNoReviewRequestReason(context, reason) {
        context.commit('setNoReviewRequestReason', reason)
    },
    setReviewRequestBy(context, id) {
        context.commit('setReviewRequestBy', id)
    },
    setRelatedLoanTiers(context, relatedTiers) {
        context.commit('setRelatedLoanTiers', relatedTiers)
    },
    setSelectedTier(context, selectedTier) {
        context.commit('setSelectedTier', selectedTier)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
